export default {
  computed: {
    vehicleShortName() {
      if (!this.vehicle?.name) return ''
      return this.vehicle.name.replace(/\s*\([\w\s,/.-]+\)\s*$/, '').trim()
    },
    vehicleYears() {
      if (!this.vehicle?.year_from) return ''
      const yearTo = this.vehicle.year_to || new Date().getFullYear()
      return ` (${this.vehicle.year_from} - ${yearTo})`
    },
    vehicleCompactYears() {
      if (!this.vehicle?.year_from) return ''
      const yearTo = this.vehicle.year_to || new Date().getFullYear()
      return ` ${this.vehicle.year_from}-${yearTo}`
    },
    displayHeadlightVehicleDetailName() {
      const name = this.headlightVehicleDetailName
      return name && name.toLowerCase() !== 'standard' ? name : ''
    },
    ledDetailLabel() {
      const detail = this.displayHeadlightVehicleDetailName
      return detail ? ' LED ' + detail : ' LED'
    },
  },
  methods: {
    vehicleHeadlightTitle({
      led = true,
      detail = true,
      years = true,
      shortName = false,
      compactYears = false,
    } = {}) {
      if (!this.vehicle) return ''
      const hasType = this.$route.query.type && this.$route.query.technologie
      const headlightType = hasType
        ? this.headlightTypeTitle
        : this.$t('pages.rechercheLedAccessoiresBrandTypeTypeid.ledBulbs')
      const detailName = detail ? this.displayHeadlightVehicleDetailName : ''
      const yearsLabel = compactYears
        ? this.vehicleCompactYears
        : this.vehicleYears

      return this.$t('pages.rechercheLedAccessoiresBrandTypeTypeid.fullTitle', {
        headlightType,
        led: led && hasType ? ' LED' : '',
        detail: detailName ? ' ' + detailName : '',
        for: this.$t('pages.rechercheLedAccessoiresBrandTypeTypeid.for'),
        brand: this.vehicle.brand.name,
        model: shortName ? this.vehicleShortName : this.vehicle.name,
        years: years ? yearsLabel : '',
      }).trim()
    },
  },
}
